var _defs, _rect, _rect2, _rect3, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g3, _g4, _g5, _g6, _path21, _path22, _g7, _g8, _g9, _g10, _g11, _g12, _g13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "1214579c50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.324219 12.964844 L 138.074219 12.964844 L 138.074219 111 L 20.324219 111 Z M 20.324219 12.964844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "afdec660e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36 122 L 122 122 L 122 130.714844 L 36 130.714844 Z M 36 122 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -15,
    height: 179.999997,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -15,
    height: 179.999997,
    fillOpacity: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -15,
    height: 179.999997,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1214579c50)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9aa1a1",
    d: "M 129.953125 110.414062 L 28.445312 110.414062 C 23.964844 110.414062 20.324219 106.78125 20.324219 102.292969 L 20.324219 21.085938 C 20.324219 16.597656 23.964844 12.964844 28.445312 12.964844 L 129.953125 12.964844 C 134.441406 12.964844 138.074219 16.597656 138.074219 21.085938 L 138.074219 102.292969 C 138.074219 106.78125 134.441406 110.414062 129.953125 110.414062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#afdec660e9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4e616d",
    d: "M 121.832031 130.714844 L 36.566406 130.714844 L 36.566406 122.59375 L 121.832031 122.59375 L 121.832031 130.714844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7d8d9c",
    d: "M 101.53125 122.59375 L 56.867188 122.59375 L 64.988281 110.414062 L 93.410156 110.414062 L 101.53125 122.59375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cdeef6",
    d: "M 129.953125 94.171875 L 28.445312 94.171875 L 28.445312 21.085938 L 129.953125 21.085938 L 129.953125 94.171875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b495a",
    d: "M 131.984375 104.324219 L 121.832031 104.324219 L 121.832031 100.261719 L 131.984375 100.261719 L 131.984375 104.324219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b495a",
    d: "M 117.773438 104.324219 L 113.710938 104.324219 L 113.710938 100.261719 L 117.773438 100.261719 L 117.773438 104.324219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b495a",
    d: "M 85.289062 104.324219 L 75.136719 104.324219 L 75.136719 100.261719 L 85.289062 100.261719 L 85.289062 104.324219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b495a",
    d: "M 30.472656 104.324219 L 26.414062 104.324219 L 26.414062 100.261719 L 30.472656 100.261719 L 30.472656 104.324219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#cd4b4c",
    d: "M 79.199219 57.628906 L 58.898438 57.628906 L 58.898438 37.328125 L 79.199219 37.328125 L 79.199219 57.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef9e1",
    d: "M 69.046875 51.539062 C 68.523438 51.539062 68.007812 51.339844 67.613281 50.945312 L 63.550781 46.882812 L 66.421875 44.011719 L 69.046875 46.636719 L 83.855469 31.832031 L 86.722656 34.703125 L 70.484375 50.945312 C 70.085938 51.339844 69.570312 51.539062 69.046875 51.539062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#cd4b4c",
    d: "M 50.777344 84.019531 C 50.007812 84.019531 49.300781 83.585938 48.960938 82.902344 L 40.839844 66.660156 C 40.339844 65.65625 40.746094 64.433594 41.742188 63.933594 C 42.75 63.433594 43.972656 63.839844 44.472656 64.835938 L 50.777344 77.453125 L 57.082031 64.835938 C 57.582031 63.839844 58.800781 63.433594 59.808594 63.933594 C 60.808594 64.433594 61.210938 65.65625 60.710938 66.660156 L 52.59375 82.902344 C 52.25 83.585938 51.546875 84.019531 50.777344 84.019531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#cd4b4c",
    d: "M 69.046875 79.960938 L 77.167969 79.960938 L 77.167969 67.78125 L 69.046875 67.78125 Z M 79.199219 84.019531 L 67.015625 84.019531 C 65.898438 84.019531 64.988281 83.109375 64.988281 81.992188 L 64.988281 65.75 C 64.988281 64.632812 65.898438 63.71875 67.015625 63.71875 L 79.199219 63.71875 C 80.316406 63.71875 81.230469 64.632812 81.230469 65.75 L 81.230469 81.992188 C 81.230469 83.109375 80.316406 84.019531 79.199219 84.019531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#cd4b4c",
    d: "M 99.5 63.71875 L 87.320312 63.71875 C 86.199219 63.71875 85.289062 64.632812 85.289062 65.75 C 85.289062 66.867188 86.199219 67.78125 87.320312 67.78125 L 91.378906 67.78125 L 91.378906 81.992188 C 91.378906 83.109375 92.292969 84.019531 93.410156 84.019531 C 94.527344 84.019531 95.441406 83.109375 95.441406 81.992188 L 95.441406 67.78125 L 99.5 67.78125 C 100.617188 67.78125 101.53125 66.867188 101.53125 65.75 C 101.53125 64.632812 100.617188 63.71875 99.5 63.71875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#cd4b4c",
    d: "M 117.773438 75.902344 C 118.890625 75.902344 119.800781 74.988281 119.800781 73.871094 C 119.800781 72.753906 118.890625 71.839844 117.773438 71.839844 L 109.652344 71.839844 L 109.652344 67.78125 L 117.773438 67.78125 C 118.890625 67.78125 119.800781 66.867188 119.800781 65.75 C 119.800781 64.632812 118.890625 63.71875 117.773438 63.71875 L 107.621094 63.71875 C 106.503906 63.71875 105.589844 64.632812 105.589844 65.75 L 105.589844 81.992188 C 105.589844 83.109375 106.503906 84.019531 107.621094 84.019531 L 117.773438 84.019531 C 118.890625 84.019531 119.800781 83.109375 119.800781 81.992188 C 119.800781 80.871094 118.890625 79.960938 117.773438 79.960938 L 109.652344 79.960938 L 109.652344 75.902344 L 117.773438 75.902344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9bb4b",
    d: "M 48.746094 37.328125 C 48.746094 39.570312 46.929688 41.386719 44.6875 41.386719 C 42.441406 41.386719 40.625 39.570312 40.625 37.328125 C 40.625 35.082031 42.441406 33.265625 44.6875 33.265625 C 46.929688 33.265625 48.746094 35.082031 48.746094 37.328125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#5181be",
    d: "M 48.746094 57.628906 L 40.625 57.628906 L 40.625 49.507812 C 40.625 47.265625 42.441406 45.449219 44.6875 45.449219 C 46.929688 45.449219 48.746094 47.265625 48.746094 49.507812 L 48.746094 57.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#87c8c2",
    d: "M 97.46875 41.386719 L 89.347656 41.386719 L 89.347656 37.328125 L 97.46875 37.328125 L 97.46875 41.386719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#87c8c2",
    d: "M 121.832031 41.386719 L 101.53125 41.386719 L 101.53125 37.328125 L 121.832031 37.328125 L 121.832031 41.386719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#87c8c2",
    d: "M 97.46875 49.507812 L 89.347656 49.507812 L 89.347656 45.449219 L 97.46875 45.449219 L 97.46875 49.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#87c8c2",
    d: "M 121.832031 49.507812 L 101.53125 49.507812 L 101.53125 45.449219 L 121.832031 45.449219 L 121.832031 49.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#87c8c2",
    d: "M 97.46875 57.628906 L 89.347656 57.628906 L 89.347656 53.570312 L 97.46875 53.570312 L 97.46875 57.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#87c8c2",
    d: "M 121.832031 57.628906 L 101.53125 57.628906 L 101.53125 53.570312 L 121.832031 53.570312 L 121.832031 57.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(156.006717, 75.075185)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 41 -13.859375 C 35.234375 -10.652344 32.753906 -9.484375 29.179688 -9.484375 C 21.230469 -9.484375 15.683594 -16.269531 15.683594 -25.535156 C 15.683594 -36.695312 20.792969 -41.582031 27.722656 -41.582031 C 31.296875 -41.582031 34.070312 -40.5625 39.101562 -37.207031 L 44.429688 -46.472656 C 39.101562 -50.484375 32.535156 -52.160156 26.699219 -52.160156 C 14.078125 -52.160156 2.1875 -45.523438 2.1875 -25.535156 C 2.1875 -5.324219 14.738281 1.09375 27.792969 1.09375 C 34.289062 1.09375 40.34375 -0.730469 46.324219 -4.597656 Z M 41 -13.859375 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.560886, 75.075185)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 35.015625 0 L 48.367188 0 L 30.128906 -51.066406 L 16.777344 -51.066406 L -1.460938 0 L 11.890625 0 L 23.492188 -32.390625 L 28.671875 -17.800781 L 20.5 -7.585938 L 32.316406 -7.585938 Z M 35.015625 0 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(256.239663, 75.075185)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.1875 -4.667969 C 7.734375 -0.800781 14.007812 1.09375 21.667969 1.09375 C 32.464844 1.09375 40.851562 -3.5 40.851562 -15.027344 C 40.851562 -25.753906 34.359375 -28.015625 26.191406 -30.785156 C 20.644531 -32.683594 15.464844 -34.140625 15.464844 -37.425781 C 15.464844 -39.394531 17.289062 -41.582031 22.25 -41.582031 C 26.261719 -41.582031 29.617188 -40.414062 35.234375 -37.207031 L 40.5625 -46.472656 C 34.871094 -50.335938 28.523438 -52.160156 22.324219 -52.160156 C 12.257812 -52.160156 3.429688 -48.074219 3.429688 -36.257812 C 3.429688 -26.335938 8.609375 -23.054688 18.675781 -19.476562 C 24.21875 -17.507812 28.816406 -15.757812 28.816406 -13.421875 C 28.816406 -10.871094 24.875 -9.484375 21.230469 -9.484375 C 16.121094 -9.484375 12.914062 -10.652344 7.515625 -13.859375 Z M 2.1875 -4.667969 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(302.052134, 75.075185)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 30.128906 0 L 30.128906 -40.851562 L 45.59375 -40.851562 L 45.59375 -51.066406 L 1.460938 -51.066406 L 1.460938 -40.851562 L 16.996094 -40.851562 L 16.996094 0 Z M 30.128906 0 "
  }))))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.748782, 0, 0, 0.75, 150.529403, 80.220583)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00246648 -0.00244389 L 269.450422 -0.00244389 ",
    stroke: "#ff914d",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.748782, 0, 0, 0.75, 150.529403, 114.652306)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00246648 0.0000507174 L 269.450422 0.0000507174 ",
    stroke: "#008037",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#004aad",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.358673, 108.890321)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 18.78125 -14.285156 L 18.664062 -9.820312 L 18.664062 0 L 23.304688 0 L 23.304688 -22.328125 L 16.433594 -22.328125 L 12.453125 -8.042969 L 8.445312 -22.328125 L 1.601562 -22.328125 L 1.601562 0 L 6.242188 0 L 6.242188 -9.820312 L 6.097656 -14.285156 L 10.078125 0 L 14.800781 0 Z M 18.78125 -14.285156 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#004aad",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(217.227026, 108.890321)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 11.277344 -6.84375 L 17.664062 -22.328125 L 12.597656 -22.328125 L 8.960938 -12.566406 L 5.296875 -22.328125 L 0.230469 -22.328125 L 6.640625 -6.84375 L 6.640625 0 L 11.277344 0 Z M 11.277344 -6.84375 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#004aad",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(235.112779, 108.890321)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#004aad",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(240.836221, 108.890321)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 12.367188 0.0585938 L 17.949219 -22.328125 L 12.96875 -22.328125 L 9.160156 -5.296875 L 5.351562 -22.328125 L 0.402344 -22.328125 L 5.984375 0.0585938 Z M 12.367188 0.0585938 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#004aad",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(259.179852, 108.890321)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.617188 0.371094 C 15.429688 0.371094 18.148438 -2.863281 18.148438 -10.59375 L 18.148438 -11.738281 C 18.148438 -19.464844 15.429688 -22.703125 9.617188 -22.703125 C 3.835938 -22.703125 1.117188 -19.464844 1.117188 -11.738281 L 1.117188 -10.59375 C 1.117188 -2.863281 3.835938 0.371094 9.617188 0.371094 Z M 9.503906 -3.636719 C 6.640625 -3.636719 5.8125 -6.125 5.8125 -10.59375 L 5.8125 -11.738281 C 5.8125 -16.203125 6.640625 -18.695312 9.503906 -18.695312 L 9.761719 -18.695312 C 12.625 -18.695312 13.425781 -16.203125 13.425781 -11.738281 L 13.425781 -10.59375 C 13.425781 -6.125 12.625 -3.636719 9.761719 -3.636719 Z M 9.503906 -3.636719 "
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#004aad",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(278.439228, 108.890321)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 10.277344 -18.320312 L 15.457031 -18.320312 L 15.457031 -22.328125 L 0.488281 -22.328125 L 0.488281 -18.320312 L 5.640625 -18.320312 L 5.640625 0 L 10.277344 0 Z M 10.277344 -18.320312 "
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#004aad",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(294.379004, 108.890321)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.601562 -22.328125 L 1.601562 0 L 15.257812 0 L 15.257812 -4.007812 L 6.242188 -4.007812 L 6.242188 -9.390625 L 13.828125 -9.390625 L 13.828125 -13.398438 L 6.242188 -13.398438 L 6.242188 -18.320312 L 15.257812 -18.320312 L 15.257812 -22.328125 Z M 1.601562 -22.328125 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f0f3e9992695c70f3047e3d69443902f.svg";
export { ForwardRef as ReactComponent };